import { createFileRoute, redirect } from '@tanstack/react-router';
import { checkRoutePermission } from '@/components/Auth/checkUserPermissions';
import { DocumentHead } from '@/components/core/DocumentHead';
import { CollectionImportDetails } from '@/components/Import/CollectionImportDetails';
import { importSearchSchema } from '@/components/Import/importSearchSchema';
import type { SearchFilter } from '@/types/filterSearch';

export const Route = createFileRoute(
  '/$tenantId/_layout/students/travels/imports/$importId',
)({
  component: TravelsImportDetailsRoute,
  validateSearch: importSearchSchema,
  beforeLoad: ({ params }) => {
    const hasPermission = checkRoutePermission({
      permission: 'organization:viewer',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function TravelsImportDetailsRoute() {
  const { tenantId, importId } = Route.useParams();
  const searchParams = Route.useSearch() as ReturnType<typeof Route.useSearch> &
    SearchFilter;

  return (
    <>
      <DocumentHead
        titleKey="page.imports.details.title"
        descriptionKey="page.imports.details.description"
      />
      <CollectionImportDetails
        importId={importId}
        studentType="travels"
        tenantId={tenantId}
        searchParams={searchParams}
      />
    </>
  );
}
